import * as fetchCreators from './fetchCreators';
import {CONFIGURATION} from '../constants/config';

const errorApiUrl = CONFIGURATION.SERVER_API_URL + "/errors/";

export function postError(error, session, stackTrace) {
  return fetchCreators.post(errorApiUrl, {error, session, stackTrace});
}
